/** Tour totals are repeated per departure; compare one tour total per window. */
export function engagementChange(current: number | null | undefined, previous: number | null | undefined): string {
  if (current == null || previous == null || previous === 0) return '—';
  const change = Math.round(((current - previous) / previous) * 100);
  const direction = change > 0 ? '▲ ' : change < 0 ? '▼ ' : '';
  return `${direction}${Math.abs(change)}% vs previous 28 days (${Math.round(previous).toLocaleString('en-AU')})`;
}
export function engagementDelayed(sample: boolean, ageDays: number): boolean {
  return !sample && ageDays > 2;
}
